import classnames from 'classnames/bind';
import { useTranslation, Trans } from 'react-i18next';
import { useSelector } from 'app/lib/hooks';
import { selectExecutingQueryCount, selectQueuedQueryCount } from 'app/store/snowflakeQueries';
import { Icon, IconSize } from 'app/components/core/Icon';
import * as styles from './WarehouseLoadDialog.css';

const cx = classnames.bind(styles);

export function ManageQueriesCard({ isActive, onClick }) {
    const { t } = useTranslation('components', { keyPrefix: 'WarehouseLoadDialog.queries' });
    const running = useSelector(selectExecutingQueryCount);
    const queued = useSelector(selectQueuedQueryCount);

    return (
        <button className={cx('action-card')} aria-pressed={isActive} onClick={onClick}>
            <Icon className={cx('icon')} variant="snowflake" size={IconSize.LARGE} />
            <p className={cx('description')}>
                <Trans
                    t={t}
                    i18nKey="description"
                    components={{ b: <strong />, br: <br /> }}
                    values={{ running, queued }}
                />
            </p>
            <p className={cx('hint')}>{t('hint')}</p>
            <div className={cx('cta')}>{t('cta')}</div>
        </button>
    );
}
